<template>
<div v-show="isModalVisible">
    <div class="modal-mask" @click="closeModal">
        <div class="modal-container" @click.stop>
        <!-- Modal Header -->
        <div class="modal-header">
            <h6 class="modal-title">Link Account</h6>
            <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
            <form @submit.prevent="accountMappingToEnterprise">
                <div class="row">
                    <div class="col-12">
                        <label>Account Name:</label>
                        <autoCompleteEnterprise
                            ref="autocomplete1"
                            :place-holder-text="placeHolderInputText"
                            :result-items="autoCompleteEnterpriseResult"
                            :on-key-up="onKeyUpAutoCompleteEnterprise"
                            :on-selected="onSelectedAutoCompleteEnterprise"
                            :auto-complete-progress="autoCompleteEnterpriseProgress"
                            :keywordSearch="account_name"
                            :classValue="'col-12 col-sm-12 ma-input-field'"
                            :styleValue="'width: 100%;'"
                            :maxlength="250">
                        </autoCompleteEnterprise>
                    </div>
                </div>
                <div class="text-center m-2">
                    <button type="submit" class="btn btn-sm btn-blue linkBtn text-center">Save</button>
                </div>
            </form>
        </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import autoCompleteEnterprise from './autocomplete_modal.vue';
import VeeValidate from 'vee-validate';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: ['enterpriseId', 'isModalVisible'],
  data() {
    return {
        loading: false,
        account_name: '',
        enterprise_accounts: [],
        placeHolderInputText: 'Search Account',
        autoCompleteEnterpriseResult: [],
        autoCompleteEnterpriseProgress: false,
    }
  },
  components: {
    autoCompleteEnterprise,
  },
  methods: {
    closeModal() {
      this.autoCompleteEnterpriseProgress = false;
      this.autoCompleteEnterpriseResult = [];
      this.$refs.autocomplete1.setValue('');
      this.$emit('close');
    },
    nameRegex: function() {
        return /^[a-zA-Z-_ ']*$/;
    },
    accountMappingToEnterprise() {
        if (this.accountId) {
            this.loading = true;
            axios('/enterprise/account-mapping',
                {
                    method: 'POST',
                    data: { enterprise_id: this.enterpriseId, account_id: this.accountId, page: '' }
                }
            )
            .then((resp) => {
                this.loading = false;
                this.$refs.autocomplete1.setValue('');
                if (resp.data.isAlreadyLinked) {
                    this.accountId = '';
                    alert('Account is already linked');
                } else {
                    this.$parent.getAccountsListData();
                    this.closeModal();
                }
            })
            .catch(error => {

            });
        } else {
            alert("Please enter the account name");
        }
    },
    onSelectedAutoCompleteEnterprise(item){
        this.autoCompleteEnterpriseProgress = false;
        this.autoCompleteEnterpriseResult = [];
        this.accountId = item.id;
        this.$refs.autocomplete1.setValue(item.account_name);
    },
    onKeyUpAutoCompleteEnterprise(keywordEntered){
        this.autoCompleteEnterpriseResult = [];
        this.account_name = keywordEntered;
        this.autoCompleteEnterpriseProgress = false;
        if(keywordEntered.length > 0){
        this.autoCompleteEnterpriseProgress = true;
        axios.get("/accounts_autocomplete", {
            params: { account_name: keywordEntered }
        })
        .then(response => {
            var newData = [];
            response.data.forEach(function(item, index){
            if(item.account_name){
                newData.push({
                'itemId' : item.account_id,
                'itemText' : item.account_name,
                'itemList': item,
                });
            }
            });
            this.autoCompleteEnterpriseResult = newData;
            this.autoCompleteEnterpriseProgress = false;
        })
        .catch(e => {
            this.autoCompleteEnterpriseProgress = false;
            this.autoCompleteEnterpriseResult = [];
        })
        } else {
            this.autoCompleteEnterpriseProgress = false;
            this.autoCompleteEnterpriseResult = [];
        }
    },
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #7d7d7d;
  font-size: 15px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.linkBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.mx-datepicker { width: 100%; }
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
@media (min-width: 1280px) { 
  .form-group {
    margin: 20px;
  }
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  min-height: 38px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/link_account_modal.vue